import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeLogo'
 * @name TypeLogoFields
 * @type {TypeLogoFields}
 * @memberof TypeLogo
 */
export interface TypeLogoFields {
    /**
     * Field type definition for field 'title' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    title?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'url' (url)
     * @name url
     * @localized false
     */
    url?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
}

/**
 * Entry skeleton type definition for content type 'logo' (Logo)
 * @name TypeLogoSkeleton
 * @type {TypeLogoSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T20:19:33.250Z
 * @version 11
 */
export type TypeLogoSkeleton = EntrySkeletonType<TypeLogoFields, "logo">;
/**
 * Entry type definition for content type 'logo' (Logo)
 * @name TypeLogo
 * @type {TypeLogo}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T20:19:33.250Z
 * @version 11
 */
export type TypeLogo<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeLogoSkeleton, Modifiers, Locales>;

export function isTypeLogo<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeLogo<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'logo'
}
